import React, {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import AccessControl from "../../../hoc/AccessControl";
import Api from "../../../Api";
import xls from "./images/xls.svg";
import OneC from "./images/1C.svg";
import Icon from "../Icon";
import classes from "./styles.module.css";

function ReportWidget({hasAccess, count, type, countLabel, name, date, filter, token, disabled}) {
    const [isLoading, setIsLoading] = useState(false);
    const [format, setFormat] = useState("csv");
    const intl = useIntl();

    const currentDate = new Date().toLocaleString(intl.locale, {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
    });

    let logo = xls;
    let text = format;

    if (type === "payout1C" || type === "transactions1C") {
        logo = OneC;
        text = "1C";
    }

    async function getReport() {
        if (isLoading) return;
        setIsLoading(true);

        try {
            const reportName = name.replace(".xls", "") + " - " + currentDate;
            await new Api({token}).getReport(type, filter, reportName, format);
        } finally {
            setIsLoading(false);
        }
    }

    if (!hasAccess) return null;

    const hasDate = date && Object.keys(date).length > 0;

    return (
        <div className={classes.Card}>
            <div className={classes.Image}>
                    <img
                        src={logo}
                        width="68"
                        height="91"
                        alt={intl.formatMessage({ id: "ReportWidget.imageAlt", defaultMessage: "Сформировать отчет" })}
                    />
            </div>

            <div className={classes.Ctrl}>
                <div className={classes.Count}>
                    {countLabel ? countLabel :
                        <FormattedMessage id="ReportWidget.operations" defaultMessage="Операций"/>}: {count}
                </div>

                {hasDate && (
                    <div className={classes.Date}>
                        {date.startDate.substring(0, 10)} - {date.endDate.substring(0, 10)}
                    </div>
                )}

                <div className={classes.SelectWrapper}>
                    <label htmlFor="formatSelect">
                        <FormattedMessage id="ReportWidget.format" defaultMessage="Формат:"/>
                    </label>
                    <select
                        id="formatSelect"
                        className={classes.Select}
                        value={format}
                        onChange={(e) => setFormat(e.target.value)}
                        disabled={isLoading}
                    >
                        <option value="csv">CSV</option>
                        <option value="xls">XLS</option>
                        <option value="xlsx">XLSX</option>
                    </select>
                </div>

                <button onClick={getReport} className={classes.Btn} disabled={disabled || isLoading}>
                    <Icon className={classes.Icon} icon="document-download" size="21px"/>
                    <FormattedMessage
                        id="ReportWidget.generate"
                        defaultMessage="Сформировать отчет {format}"
                        values={{format: text.toUpperCase()}}
                    />
                </button>
            </div>
        </div>
    );
}

export default AccessControl(ReportWidget);



// WEBPACK FOOTER //
// ./src/Components/Utils/ReportWidget/index.js